import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-focus-numbers.component.scss';
var ContentFocusNumbers = /** @class */ (function (_super) {
    tslib_1.__extends(ContentFocusNumbers, _super);
    function ContentFocusNumbers(element) {
        return _super.call(this, element) || this;
    }
    ContentFocusNumbers.prototype.init = function () {
    };
    ContentFocusNumbers.prototype.bindEvents = function () {
    };
    return ContentFocusNumbers;
}(Base));
export { ContentFocusNumbers };



//////////////////
// WEBPACK FOOTER
// ./components/content-focus-numbers/content-focus-numbers.component.ts
// module id = 743
// module chunks = 0